module.exports = __webpack_public_path__ + "img/no-data-logs.94e4b8ea.svg";